import CallAPI from "@/functions/Cl_api";
import { Cl_common } from "@/functions/Cl_common";
import { DtoRequestLoasGetReqImple } from "furukawa-common/src/common/dto/DtoRequestLoasGetReqImple";
import { DtoRequestLoasGetResImple } from "furukawa-common/src/common/dto/DtoRequestLoasGetResImple";
import { DtoRequestLoasPostReq } from "furukawa-common/src/common/dto/abst/DtoRequestLoasPostReq";
import { DtoRequestLoasPostRes } from "furukawa-common/src/common/dto/abst/DtoRequestLoasPostRes";
import { DtoRequestLoasPutReq } from "furukawa-common/src/common/dto/abst/DtoRequestLoasPutReq";
import { DtoRequestLoasPutRes } from "furukawa-common/src/common/dto/abst/DtoRequestLoasPutRes";
import { DtoRequestLoasDeleteReq } from "furukawa-common/src/common/dto/abst/DtoRequestLoasDeleteReq";
import { DtoRequestLoasDeleteRes } from "furukawa-common/src/common/dto/abst/DtoRequestLoasDeleteRes";

export class Cl_requestloa {
  public static async getList(
    dto: DtoRequestLoasGetReqImple
  ): Promise<DtoRequestLoasGetResImple> {
    return Object.assign(
      new DtoRequestLoasGetResImple(),
      await CallAPI.getRequest(
        "/requestLoas?" +
          Cl_common.cnvObj2GetParam(dto.pager) +
          "&" +
          Cl_common.cnvObj2GetParam(dto)
      )
    );
  }

  public static async get(
    dto: DtoRequestLoasGetReqImple
  ): Promise<DtoRequestLoasGetResImple> {
    return Object.assign(
      new DtoRequestLoasGetResImple(),
      await CallAPI.getRequest("/requestLoas/" + dto.c_request_loa_id)
    );
  }

  public static async post(
    dto: DtoRequestLoasPostReq
  ): Promise<DtoRequestLoasPostRes> {
    return Object.assign(
      new DtoRequestLoasPostRes(),
      await CallAPI.postRequest("/requestLoas", dto)
    );
  }

  public static async put(
    dto: DtoRequestLoasPutReq
  ): Promise<DtoRequestLoasPutRes> {
    return Object.assign(
      new DtoRequestLoasPutRes(),
      await CallAPI.putRequest("/requestLoas/" + dto.c_request_loa_id, dto)
    );
  }

  public static async del(
    dto: DtoRequestLoasDeleteReq
  ): Promise<DtoRequestLoasDeleteRes> {
    return Object.assign(
      new DtoRequestLoasDeleteRes(),
      await CallAPI.deleteRequest(
        "/requestLoas?" + Cl_common.cnvObj2GetParam(dto)
      )
    );
  }
}
